// Car brands for valet logging — most used in KSA first. Logos served from /car-logos/*.png
export const CAR_BRANDS = [
  { name: "Mercedes", file: "mercedes-benz" },
  { name: "BMW", file: "bmw" },
  { name: "Lexus", file: "lexus" },
  { name: "Ford", file: "ford" },
  { name: "GMC", file: "gmc" },
  { name: "Toyota", file: "toyota" },
  { name: "Nissan", file: "nissan" },
  { name: "Jetour", file: "jetour" },
  { name: "Audi", file: "audi" },
  { name: "Hyundai", file: "hyundai" },
  { name: "Kia", file: "kia" },
  { name: "Chevrolet", file: "chevrolet" },
  { name: "Land Rover", file: "land-rover" },
  { name: "Porsche", file: "porsche" },
  { name: "Honda", file: "honda" },
  { name: "Mazda", file: "mazda" },
  { name: "Cadillac", file: "cadillac" },
  { name: "Dodge", file: "dodge" },
  { name: "Jeep", file: "jeep" },
  { name: "Infiniti", file: "infiniti" },
  { name: "Genesis", file: "genesis" },
  { name: "Changan", file: "changan" },
  { name: "Geely", file: "geely" },
  { name: "MG", file: "mg" },
  { name: "Haval", file: "haval" },
  { name: "Mitsubishi", file: "mitsubishi" },
  { name: "Suzuki", file: "suzuki" },
  { name: "Volkswagen", file: "volkswagen" },
  { name: "Isuzu", file: "isuzu" },
  { name: "Tesla", file: "tesla" },
  { name: "Lincoln", file: "lincoln" },
  { name: "Chrysler", file: "chrysler" },
];

export const CAR_COLORS = [
  { name: "White", hex: "#f8f8f8" },
  { name: "Black", hex: "#111111" },
  { name: "Silver", hex: "#c7c9cc" },
  { name: "Gray", hex: "#6f7378" },
  { name: "Red", hex: "#c81e1e" },
  { name: "Blue", hex: "#1d4ed8" },
  { name: "Navy", hex: "#172554" },
  { name: "Brown", hex: "#6b4423" },
  { name: "Beige", hex: "#d9c7a7" },
  { name: "Gold", hex: "#c9a227" },
  { name: "Green", hex: "#166534" },
  { name: "Orange", hex: "#ea7317" },
  { name: "Yellow", hex: "#eab308" },
  { name: "Maroon", hex: "#6d1a2d" },
];

export const colorHex = (name) => CAR_COLORS.find((c) => c.name.toLowerCase() === (name || "").toLowerCase())?.hex || null;

export const brandLogo = (name) => {
  const b = CAR_BRANDS.find((x) => x.name.toLowerCase() === (name || "").toLowerCase());
  return b ? `/car-logos/${b.file}.png` : null;
};
